// extracted by mini-css-extract-plugin
export default {"App":"App_App__bEC4k","App-logo":"App_App-logo__CCMEX","App-logo-spin":"App_App-logo-spin__6icLL","App-header":"App_App-header__w1P58","App-link":"App_App-link__QxdVN"};